<template>
  <div class="flex flex-col gap-4 h-full">
    <button @click="goToBack" class="flex gap-2 text-primary-0 items-center">
      <i class="w-5" v-icon:arrow-left></i>
      {{ 'Volver al buscador' }}
    </button>
    <div class="flex flex-col gap-8 flex-grow">
      <div class="flex gap-3 items-start">
        <i class="w-12 text-[#2640F9]" v-icon:[icon]></i>
        <div class="w-1 flex-grow">
          <h3 class="font-nunito text-lg leading-snug font-bold">
            <slot name="title" :value="item.nom">
              {{item.nom}}
            </slot>
          </h3>
          <div class="flex gap-2 items-center flex-wrap">
            <div class="flex gap-2 items-center w-full">
              <i v-icon:map class="w-6 text-primary-0"></i>
              <div class="w-1 flex-grow text-sm">
                {{ item.dir }}
              </div>
              <div>
                <slot name="tools"></slot> 
              </div>
            </div>
            <div v-if="item.tie" class="flex gap-2 items-center w-full">
              <div class="w-1 flex-grow text-xs text-primary-dark-40">
                {{ item.tie }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-col gap-8 h-1 flex-grow overflow-auto">
        <div v-if="item.price && item.price.length" class="flex flex-col gap-4">
          <h3 class="text-base font-nunito font-bold">Precio</h3>
          <div class="flex flex-wrap gap-6">
            <div class="flex flex-col" v-for="(product, index) in item.price"
              :key="`product-${_uid}-${index}-${item.lat}-${item.lon}`">
              <span class="text-sm">{{ product.productName }}</span>
              <b>{{ product.retailPrice | filterPrice }}</b>
            </div>
          </div>
        </div>
        <div class="flex flex-col gap-4">
          <h3 v-if="item.tip == 'eds'" class="text-base font-nunito font-bold">Aquí encontrarás una Tienda Altoque</h3>
          <figure>
            <img class="rounded-lg w-full" src="https://placehold.co/308x120" alt="">
          </figure>
        </div>
        <div v-if="item.services && item.services.length" class="flex flex-col gap-4">
          <h3 class="text-base font-nunito font-bold">Lo que esta EDS ofrece</h3>
          <ul class="flex flex-col gap-2 marker:text-primary-0 list-disc pl-5">
            <template v-for="(service, index) in item.services">
              <li v-if="service.name"
                :key="`service-${_uid}-${index}-${item.lat}-${item.lon}`" >
                {{ service.name.includes('Lubriplus') ? service.name.replace('Lubriplus', 'Masterlub') : service.name}}
              </li>
            </template>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VMapCardDetail",
  props: ['item', 'icon'],
  methods: {
    goToBack(){
      this.$emit("go-to-back");
    }
  }
}
</script>

<style lang="scss" scoped></style>